// filterView/parts/valueInput.js — the value control of one condition (plan documents_admin-search, phase
// filter-varianten): text → text field, list → select of the field's choices, date → native date field (sends
// YYYY-MM-DD, User 2026-10-13), a mode without value → a dash. One instance per field and "needs a value"; the row
// builds a new one when either changes.
//
// createValueInput({ field, needsValue, value, onInput, label, emptyLabel, id }) → { element, setValue, focus, destroy }
//   emptyLabel: a list select starts with this choice of value '' (form C: "alle" = no condition)
//   id: for a <label for> (form C)

import { createDisposers } from '../../core/disposers.js';

function build(field, needsValue, emptyLabel) {
    if (!needsValue) {
        const dash = document.createElement('span');
        dash.className = 'topo2-filterview-novalue';
        dash.textContent = '—';
        return dash;
    }
    if (field.kind === 'list') {
        const select = document.createElement('select');
        select.className = 'topo2-field--bordered topo2-filterview-select';
        if (emptyLabel !== undefined) {
            select.append(new Option(emptyLabel, ''));
        }
        for (const option of field.options ?? []) {
            select.append(new Option(option.label, option.value));
        }
        return select;
    }
    const input = document.createElement('input');
    input.type = field.kind === 'date' ? 'date' : 'text';
    input.className = 'topo2-field-textinput topo2-field--bordered topo2-filterview-text';
    return input;
}

export function createValueInput({ field, needsValue, value = '', onInput, label, emptyLabel, id }) {
    const disposers = createDisposers();
    const element = build(field, needsValue, emptyLabel);
    const isControl = needsValue;

    if (isControl) {
        if (id) {
            element.id = id;
        } else {
            element.setAttribute('aria-label', label);
        }
        element.value = value;
        const handler = () => onInput(element.value);
        // a select or date field reports through change as well; typing in a text field through input
        const type = element.tagName === 'SELECT' ? 'change' : 'input';
        element.addEventListener(type, handler);
        disposers.add(() => element.removeEventListener(type, handler));
    }

    return {
        element,
        // Shows `next` unless the control holds it already (no reset of the caret while typing).
        setValue(next) {
            if (isControl && element.value !== next) {
                element.value = next;
            }
        },
        focus() {
            if (isControl) {
                element.focus();
            }
        },
        destroy() {
            disposers.dispose();
        },
    };
}
